module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container\"> <div class=\"row pt-4\"> <div class=\"col-sm-7 col-lg-4 mx-auto\"> <div class=\"row\"> <div class=\"col-6 text-center mb-6 mx-auto\"> <a href=\"/\"> <img src=\"/assets/images/branding/easypost-primary-logo.svg\" class=\"img-fluid mx-auto\"> </a> </div> </div> <form id=\"login-form\"> <label for=\"#session-email\">Email Address</label> <div class=\"form-group\"> <input class=\"form-control\" id=\"session-email\" name=\"session[email]\" placeholder=\"Email Address\" tabindex=\"1\" type=\"text\" value=\"")
    ; __append(escapeFn( locals.email ))
    ; __append("\"> </div> <label for=\"#session-password\" class=\"d-block\">Password <a href=\"/reset\" class=\"pull-right\">Forgot Password?</a></label> <div class=\"form-group\"> <input class=\"form-control\" id=\"session-password\" name=\"session[password]\" tabindex=\"2\" placeholder=\"Password\" type=\"password\"> </div> <button class=\"btn btn-secondary btn-lg btn-block\" type=\"submit\" tabindex=\"3\">Sign In</button> </form> </div> </div> </div> <div class=\"text-center my-6\"> <h5>Don't have an account?</h5> <a class=\"btn btn-clear\" href=\"/signup\">Sign up</a> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/sign_in/template.ejs
// module id = 1165
// module chunks = 1